"use client";

import { useState, useEffect } from "react";
import { useTranslations } from "next-intl";
import { usePathname } from "@/i18n/navigation";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const t = useTranslations("cookie");

  useEffect(() => {
    if (typeof window === "undefined") return;
    const dismissed = window.localStorage.getItem("ss-cookies");
    if (!dismissed) setShow(true);
  }, []);

  function dismiss(choice: "accept" | "reject") {
    window.localStorage.setItem("ss-cookies", choice);
    setShow(false);
  }

  // Never on /checkout: on a phone the banner sat on top of the price and the
  // pay bar. It returns on the next page; nothing is stored until they choose.
  const pathname = usePathname();
  if (!show || pathname?.startsWith("/checkout")) return null;

  return (
    <div className="fixed bottom-24 end-6 start-6 sm:start-auto sm:max-w-[340px] bg-white border border-ss-line rounded-[14px] p-4 shadow-[var(--shadow-ss-xl)] z-40 fade-up">
      <h4 className="font-bold text-sm mb-1.5">{t("title")}</h4>
      <p className="text-[13px] text-ss-muted mb-3.5 leading-relaxed">
        {t("body")}
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => dismiss("accept")}
          className="flex-1 bg-ss-blue text-white text-xs font-semibold py-2 rounded-full"
        >
          {t("accept")}
        </button>
        <button
          type="button"
          onClick={() => dismiss("reject")}
          className="flex-1 bg-white border border-ss-line text-xs font-semibold py-2 rounded-full"
        >
          {t("essentialOnly")}
        </button>
      </div>
    </div>
  );
}
